import { OrderData } from '../types';

export const mockOrders: OrderData[] = [
  {
    orderId: "514852",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Laura",
    lastName: "Giacomozzi",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B225",
    owner: "Admin Oz Hair & Beauty",
    priority: "Medium",
    internalNote: "",
    total: 64.95,
    deliveryDate: "2023/02/01"
  },
  {
    orderId: "514853",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Bianca",
    lastName: "Leonard",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B226",
    owner: "Admin Oz Hair & Beauty",
    priority: "High",
    internalNote: "",
    total: 115.00,
    deliveryDate: "2023/02/01"
  },
  {
    orderId: "514857",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Sally",
    lastName: "Medwin",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B230",
    owner: "Admin Oz Hair & Beauty",
    priority: "Medium",
    internalNote: "",
    total: 57.85,
    deliveryDate: "2023/02/01"
  },
  {
    orderId: "514860",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Mel",
    lastName: "Coslowski",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B233",
    owner: "Admin Oz Hair & Beauty",
    priority: "Medium",
    internalNote: "",
    total: 473.00,
    deliveryDate: "2023/02/01"
  },
  {
    orderId: "514862",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Courtney",
    lastName: "Arnold",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B235",
    owner: "Admin Oz Hair & Beauty",
    priority: "Medium",
    internalNote: "",
    total: 161.00,
    deliveryDate: "2023/02/01"
  },
  {
    orderId: "514864",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Amal",
    lastName: "Ibrahim",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B237",
    owner: "Admin Oz Hair & Beauty",
    priority: "Medium",
    internalNote: "",
    total: 48.99,
    deliveryDate: "2023/02/01"
  },
  {
    orderId: "514865",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Kathy",
    lastName: "Udeh",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B238",
    owner: "Admin Oz Hair & Beauty",
    priority: "Medium",
    internalNote: "",
    total: 57.90,
    deliveryDate: "2023/02/01"
  },
  {
    orderId: "514867",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Caitlyn",
    lastName: "Grace",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B240",
    owner: "Admin Oz Hair & Beauty",
    priority: "Medium",
    internalNote: "",
    total: 83.54,
    deliveryDate: "2023/02/01"
  },
  {
    orderId: "514869",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Tashika",
    lastName: "Renouf",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B242",
    owner: "Admin Oz Hair & Beauty",
    priority: "Medium",
    internalNote: "",
    total: 92.80,
    deliveryDate: "2023/02/01"
  },
  {
    orderId: "514871",
    orderDate: "31/01/2023",
    type: "Sales Order",
    firstName: "Susanne",
    lastName: "Angelis",
    account: "",
    status: "Printed",
    location: "Caringbah Warehouse",
    poNumber: "OZ18-B244",
    owner: "Admin Oz Hair & Beauty",
    priority: "High",
    internalNote: "",
    total: 263.00,
    deliveryDate: "2023/02/01"
  }
]; 